import React from 'react';
import { connect } from 'react-redux';
import { charClear } from '../../../actions/char';

export class OwnClear extends React.Component {
	onClick = () => {
    	this.props.charClear(true);
    }
    render() {
        return (
            <div id="own-clear" className="panel" onClick={this.onClick}></div>
        );
    }
};

const mapDispatchToProps = (dispatch) => ({
    charClear: (charClearState) => dispatch(charClear(charClearState))
});

export default connect(undefined, mapDispatchToProps)(OwnClear);


// WEBPACK FOOTER //
// ./src/components/sections/own/OwnClear.js